export default "__VITE_ASSET__DAXG9zQp__"